import { breakpoints, viewports } from 'app/constants/breakpoints';

const constraints = [
  {
    viewport: viewports.SMALL,
    minWidth: breakpoints.SMALL,
  },
  {
    viewport: viewports.MEDIUM,
    minWidth: breakpoints.MEDIUM,
  },
  {
    viewport: viewports.LARGE,
    minWidth: breakpoints.LARGE,
  },
  {
    viewport: viewports.X_LARGE,
    minWidth: breakpoints.X_LARGE,
  },
];

const constraintsByViewport = {};
constraints.forEach(constraint => {
  constraintsByViewport[constraint.viewport] = constraint;
});

const getViewportForWidth = width => {
  let i = constraints.length - 1;
  while (i >= 0 && width < constraints[i].minWidth) {
    i--;
  }

  return constraints[i].viewport;
};

export default viewports;

export { constraints, constraintsByViewport, getViewportForWidth };



// WEBPACK FOOTER //
// ./src/utils/viewports.js